import { Injectable }               from "@angular/core";
import { NavigationStart, Router }  from "@angular/router";
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class AlertService {
  private subject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private keepAfterNavigationChange = false;

  constructor(private router: Router) {
    // clear alert message on route change
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.clear();
        }
      }
    });
  }

  default(message: string, keepAfterNavigationChange = false, title?: string, theme?: string, iconPath?: string) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: "default", text: message, title, theme, iconPath });
  }

  error(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: "error", text: message });
  }

  errorWithButton(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: "errorButton", text: message });
  }

  errorWithLink(message_1: string, message_2: string, linkData, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: "errorLink", message_1, message_2, link: linkData });
  }

  success(message: string, keepAfterNavigationChange = false, title?: string, theme?: string ) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: "success", text: message, title, theme });
  }

  renewal(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: "renewal", text: message });
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  clear(): void {
    this.subject.next(null);
  }
}
